module.exports = __webpack_public_path__ + "img/twitter-x-logo.8566fafd.png";